import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstacleHorizontalMoveBehavior extends ObstacleBehavior {
  private time: number = 0;
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstacleHorizontal', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {
    this.time += deltaTime * this.config.speed;
    const offset = Math.sin(this.time) * this.config.width;
    // Assuming horizontal is X axis, relative to path would be better but simple X for now
    // Actually, usually horizontal refers to lateral movement relative to path.
    // Since spawn position is already transformed to path space, we might want to oscillate along X or Z depending on orientation.
    // However, existing behaviors usually move in world space.
    // Let's assume X axis for simplicity unless path info is used.
    this.mesh.position.x = this.startPosition.x + offset;
  }
  clone(): ObstacleHorizontalMoveBehavior {
    return new ObstacleHorizontalMoveBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
